import { useDispatch } from 'react-redux';
import moment from 'moment';
import { fetchCalendarPickerItems, getRecurringWorkoutsByDate } from '../../../ducks/calendarActions';

const useRefetchRecurringData = () => {
  const dispatch = useDispatch();

  const refetchRecurringData = ({
    currentUser,
    currentMonth,
    nextMonth,
    selectedReduxCalendar,
    selectedReduxAthlete,
    closeModal,
  }) => {
    const firstMonthStart = moment(currentMonth).startOf('month').format('YYYY-MM-DD');
    const secondMonthEnd = moment(nextMonth).endOf('month').format('YYYY-MM-DD');

    dispatch(fetchCalendarPickerItems(currentUser, firstMonthStart, secondMonthEnd));

    if (selectedReduxCalendar?.id) {
      dispatch(getRecurringWorkoutsByDate(
        currentUser,
        firstMonthStart,
        secondMonthEnd,
        selectedReduxCalendar.id,
        false,
        {
          onSuccess: () => closeModal(),
          onError: () => closeModal(),
        },
      ));
    } else if (selectedReduxAthlete?.id) {
      dispatch(getRecurringWorkoutsByDate(
        currentUser,
        firstMonthStart,
        secondMonthEnd,
        selectedReduxAthlete.id,
        true,
        {
          onSuccess: () => closeModal(),
          onError: () => closeModal(),
        },
      ));
    }
  };

  return refetchRecurringData;
};

export default useRefetchRecurringData;
